<template>
  <div>
    <a-modal :visible="modalVisible" :title="data" :closable="false" :width="900" ok-cancel="false" @cancel="closeModal">
      <a-table :columns="modalDataColumns" :data-source="tableData" :width="850" row-key="pipeline_id">
        <span slot="gitlabUrl" slot-scope="text, record">
          <a :href="record.gitlab_url">{{ record.gitlab_url }}</a>
        </span>
      </a-table>
      <div slot="footer" />
    </a-modal>
  </div>
</template>
<script>
export default {
  data() {
    return {
      modalVisible: false,
      data: [],
      tableData: [],
      modalDataColumns: [
        {
          title: '流水线ID',
          width: 120,
          dataIndex: 'pipeline_id',
          scopedSlots: { customRender: 'pipelineId' }
        },
        {
          title: '地址',
          width: 600,
          dataIndex: 'gitlab_url',
          scopedSlots: { customRender: 'gitlabUrl' }
        },
        {
          title: '失败数量',
          width: 120,
          dataIndex: 'fail_num',
          scopedSlots: { customRender: 'failNum' },
          sorter: (a, b) => b.fail_num - a.fail_num
        }
      ]
    };
  },
  methods: {
    closeModal() {
      this.modalVisible = false;
    },
    showModal(getData, getTableData) {
      this.modalVisible = true;
      this.data = getData;
      this.tableData = getTableData;
    }
  }
};
</script>
